import React, { useContext } from 'react';
import { AuthContext } from '../store/ContextStore';

function ToastNotification() {
    const { toasts } = useContext(AuthContext);

    const colors = {
        "red":"#C22222",
        "yellow":"#D39324",
        "green":"#5A972C"
    }

    return (
        <div className="fixed top-2 right-2 flex flex-col gap-2 w-[98%] z-50">
            {toasts &&
                toasts.map((toast: any, index: number) => {
                    return (
                        <div
                            key={index}
                            className={`relative flex items-center justify-center p-2 rounded-md shadow-md text-white w-full animate-slide-in`}
                            style={{ backgroundColor: colors[toast.color as keyof typeof colors] || '#F1C617' }} // Dynamically set background
                        >
                            <p>{toast.message}</p>
                            {/* <button
                                className="absolute top-1 right-1 text-black cursor-pointer"
                                onClick={() => toastValue.closeToast(toast.id)}
                            >
                                {"\u274c"}
                            </button> */}
                        </div>
                    );
                })}
        </div>
    );
}

export default ToastNotification;
